let AbstractImporter = require('../../io/import/abstractImporter');

/**
 * Класс JsonImporter
 * @extends AbstractImporter
 */
class JsonImporter extends AbstractImporter{
  constructor(params){
    super(params);
  }
}

module.exports = JsonImporter;